import React from "react";
import { useSelector } from "react-redux";
import Card from "components/card";
import { Tabs } from 'antd';

import PayrunDtrTable from "../../../console/payrolls/components/PayrunDtrTable";
import PayrunOtTable from "../../../console/payrolls/components/PayrunOtTable";
import PayrunNdTable from "../../../console/payrolls/components/PayrunNdTable";

const FinalPayDtr = () => {

	const recordData = useSelector((state) =>state.finalPay.finalPayDetails?.data);

	const items = [
		{
			key: '1',
			label: 'DTR',
			children: <PayrunDtrTable payrunIds={recordData?.fpa_payrun_ids} mode="edit"/>,
		},
		{
			key: '2',
			label: 'Overtime',
			children: <PayrunOtTable payrunIds={recordData?.fpa_payrun_ids} mode="edit"/>,
		},
		{
			key: '3',
			label: 'Night Differential',
			children: <PayrunNdTable payrunIds={recordData?.fpa_payrun_ids} mode="edit"/>,
		},
	];
  
  	return (
		<div>
			<Card extra={"w-full h-full p-4"}>
				<Tabs defaultActiveKey="1" items={items}/>
			</Card>
		</div>
		
  	);
};

export default FinalPayDtr;
